import { createDateTimeColumn } from '@app/components/date/create-date-time-column';
import { createCustomIdColumn } from '@app/modules/audit/components/create-custom-id-column';
import { auditReports } from '@mi-front/api-clients';
import { MrtTable } from '@mi-front/ui';
import { useIntl } from 'react-intl';

export function UnverifiedLtxEntriesTable({ data }: { data: auditReports.LtxEntryDto[] }) {
  const { $t } = useIntl();

  return (
    <MrtTable
      data={data}
      columns={[
        createDateTimeColumn<auditReports.LtxEntryDto>($t, {
          accessor: (row) => row.datetime,
          enableColumnFilter: false,
          filterVariant: 'time-range',
          size: 150,
        }),
        createCustomIdColumn<auditReports.LtxEntryDto>($t, {
          accessor: (row) => row.customId,
          enableColumnFilter: true,
          filterFn: 'contains',
        }),
        {
          id: 'name',
          header: $t({
            id: 'audit.reportsScreen.ltxMatches.unverifiedLtxEntries.name',
            defaultMessage: 'Nombre',
          }),
          accessorKey: 'name',
          enableSorting: true,
          enableColumnFilter: true,
          filterFn: 'contains',
        },
        {
          id: 'type',
          header: $t({
            id: 'audit.reportsScreen.ltxMatches.unverifiedLtxEntries.type',
            defaultMessage: 'Tipo',
          }),
          accessorKey: 'type',
          enableSorting: true,
          enableColumnFilter: true,
          filterFn: 'equals',
          size: 120,
        },
      ]}
    />
  );
}
